import { useState } from "react";

const faqs = [
    {
        tag: "p",
        question: "What is hotel price intelligence?",
        answer:
            "Hotel price intelligence is the process of tracking competitor room rates, demand trends, and market data using a hotel analytics platform. It helps hotels improve their hotel pricing strategy, optimize rates, and increase revenue.",
    },
    {
        tag: "p",
        question: "How does hotel competitor analysis help increase bookings?",
        answer:
            "Hotel competitor analysis helps you compare competitor pricing, amenities, and reviews. With accurate competitor pricing for hotels and hotel market intelligence, you can adjust your pricing strategy and attract more bookings.",
    },
    {
        tag: "p",
        question: "What is hotel pricing intelligence software?",
        answer:
            "Hotel pricing intelligence software, also known as hotel rate comparison software, helps track competitor prices, analyze trends, and provide insights for better decision-making. It is a key part of modern hotel business intelligence systems.",
    },
    {
        tag: "p",
        question: "How does AI improve hotel price intelligence and competitor analysis?",
        answer:
            "AI enhances hotel price intelligence by analyzing large datasets like competitor pricing, guest reviews, and booking patterns. It delivers AI-powered hotel market intelligence and actionable insights for smarter pricing decisions.",
    },
    {
        tag: "p",
        question: "Can I track competitor pricing across multiple OTAs using this tool?",
        answer:
            "Yes, this hotel analytics platform tracks competitor pricing across multiple OTAs and provides real-time hotel competitive benchmarking, helping you stay ahead in a competitive market.",
    },
    {
        tag: "p",
        question: "What is hotel competitive benchmarking?",
        answer:
            "Hotel competitive benchmarking is the process of comparing your hotel’s pricing, performance, and amenities against competitors. It is essential for building a strong hotel pricing strategy and improving market position.",
    },
    {
        tag: "p",
        question: "Is this platform suitable for small hotels and boutique properties?",
        answer:
            "Yes, Prowen is designed for independent hotels, boutique properties, and small chains looking for simple and effective hotel business intelligence and hotel revenue analytics solutions.",
    },
    {
        tag: "p",
        question: "Do I need a revenue manager to use hotel analytics software?",
        answer:
            "No, with Prowen’s managed hotel intelligence and user-friendly dashboard, hotel owners can access hotel market intelligence and pricing insights without needing a dedicated revenue manager.",
    },
    {
        tag: "p",
        question: "How does hotel revenue analytics help increase revenue?",
        answer:
            "Hotel revenue analytics uses data from pricing trends, competitor analysis, and booking patterns to optimize pricing. This helps improve occupancy, ADR, and overall revenue performance.",
    },
    {
        tag: "p",
        question: "How can hotels increase bookings using hotel market intelligence?",
        answer:
            "Hotels can increase bookings by using hotel market intelligence and dynamic pricing for hotels to adjust rates, improve offerings, and respond quickly to competitor pricing changes.",
    },
];

function QuestionTag({ tag, className, children }) {
    const Tag = tag;
    return <Tag className={className}>{children}</Tag>;
}

function FAQItem({ faq, isOpen, onToggle }) {
    return (
        <div className="border-b border-slate-100 last:border-b-0">
            <button
                onClick={onToggle}
                className="w-full flex items-start justify-between gap-4 px-6 py-5 text-left hover:bg-slate-50 transition-colors duration-150"
            >
                <QuestionTag
                    tag={faq.tag}
                    className="text-sm font-semibold text-slate-800 leading-snug m-0 pr-2"
                >
                    {faq.question}
                </QuestionTag>

                <span
                    className={`flex-shrink-0 mt-0.5 w-5 h-5 rounded-full border flex items-center justify-center transition-all duration-200 ${isOpen
                        ? "border-indigo-300 bg-indigo-50"
                        : "border-slate-300"
                        }`}
                >
                    <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        stroke={isOpen ? "#6366f1" : "#94a3b8"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        className={`transition-transform duration-250 ${isOpen ? "rotate-45" : "rotate-0"}`}
                    >
                        <line x1="5" y1="1" x2="5" y2="9" />
                        <line x1="1" y1="5" x2="9" y2="5" />
                    </svg>
                </span>
            </button>

            <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-60" : "max-h-0"
                    }`}
            >
                <p className="px-6 pb-5 text-sm text-slate-500 leading-relaxed m-0">
                    {faq.answer}
                </p>
            </div>
        </div>
    );
}

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="max-w-3xl mx-auto px-6 py-20">
            {/* Header */}
            <div className="mb-12 text-center">
                <span className="inline-block text-xs font-semibold uppercase tracking-widest text-indigo-600 bg-indigo-50 px-3 py-1 rounded-full">
                    FAQ
                </span>
                <p className="mt-5 text-4xl font-bold text-slate-900 leading-tight">
                    Frequently asked questions
                </p>
                <p className="mt-4 text-slate-500 text-lg max-w-xl mx-auto">
                    Hotel Price Intelligence & Competitor Analysis
                </p>
            </div>

            {/* FAQ List */}
            <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden divide-y divide-slate-100">
                {faqs.map((faq, index) => (
                    <FAQItem
                        key={index}
                        faq={faq}
                        isOpen={openIndex === index}
                        onToggle={() => handleToggle(index)}
                    />
                ))}
            </div>
        </section>
    );
}